// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wi01","comment":"styles_comment__2dVg8"};